import axios from "../axios";

export const all = (locale = 'tr') => {
    return axios.get('/api/collections/other_page/entries?filter[site]=' + locale);
};

export const find = (id) => {
    return axios.get('/api/collections/other_page/entries/' + id);
};
